import React from 'react';
import '../styles/components/footer.css';

export default function Footer({ onNavigate }) {
  const goTo = (section) => onNavigate(`/#${section}`);

  return (
    <footer className="site-footer">
      <div className="site-footer__top">
        <div className="site-footer__brand">
          <a href="/" onClick={(event) => { event.preventDefault(); onNavigate('/'); }} aria-label="Aurora Projectos, início">
            <img src="/images/logo.png" alt="Aurora Projectos" />
          </a>
          <span className="font-label">Arquitetura &amp; Expografia</span>
        </div>

        <div className="site-footer__cols">
          <div>
            <span>Estúdio</span>
            <button onClick={() => goTo('estudio')} className="site-footer__link">Sobre</button>
            <button onClick={() => goTo('equipe')} className="site-footer__link">Equipe</button>
            <button onClick={() => goTo('processo')} className="site-footer__link">Processo</button>
          </div>
          <div>
            <span>Projetos</span>
            <button onClick={() => onNavigate('/?sector=residential#projetos')} className="site-footer__link">Residencial</button>
            <button onClick={() => onNavigate('/?sector=commercial#projetos')} className="site-footer__link">Comercial</button>
            <button onClick={() => onNavigate('/?sector=expography#projetos')} className="site-footer__link">Expografia</button>
          </div>
          <div>
            <span>Siga</span>
            <a href="https://www.instagram.com/auroraprojetos/" rel="noopener noreferrer" className="site-footer__link">Instagram</a>
            <a href="mailto:maria@auroraprojetos.com" className="site-footer__link">E-mail</a>
          </div>
        </div>
      </div>

      <p className="site-footer__bottom">© {new Date().getFullYear()} Aurora Projectos. Recife, PE.</p>
    </footer>
  );
}
